import Typography from '@mui/material/Typography';
import { Box } from '@mui/material';
import './Section1.scss';
import sectionConstants from '../../constants/SectionConstants';

export const Section1 = () => {
  return (
    <Box className={`content`}>
      <Typography component='h4' className={`heading dark-blue`}>
        {sectionConstants.Overview}
      </Typography>
      <Typography component='h5' className={`subHeading dark-blue`}>
        <Box mb={2} mt={3}>
          {sectionConstants.Overview1}
        </Box>
        <Box mb={2}>{sectionConstants.Overview2}</Box>
        <Box mb={2}>{sectionConstants.Overview3}</Box>
        <Box mb={3}>{sectionConstants.Overview4}</Box>
      </Typography>
      <Typography component='h4' className={`heading dark-blue`}>
        {sectionConstants.OnlineWeb}
      </Typography>
      <Typography component='h5' className={`subHeading dark-blue`}>
        <Box mb={2} mt={3}>
          {sectionConstants.OnlineWeb1}
        </Box>
        <Box mb={2}>{sectionConstants.OnlineWeb2}</Box>
        <Box mb={2}>{sectionConstants.OnlineWeb3}</Box>
        <Box mb={3}>{sectionConstants.OnlineWeb4}</Box>
      </Typography>
      <Typography component='h4' className={`heading dark-blue`}>
        {sectionConstants.GeneralConditions}
      </Typography>
      <Typography component='h5' className={`subHeading dark-blue`}>
        <Box mb={2} mt={3}>
          {sectionConstants.GeneralConditions1}
        </Box>
        <Box mb={2}>{sectionConstants.GeneralConditions2}</Box>
        <Box mb={2}>{sectionConstants.GeneralConditions3}</Box>
        <Box mb={3}>{sectionConstants.GeneralConditions4}</Box>
      </Typography>
      <Typography component='h4' className={`heading dark-blue`}>
        {sectionConstants.AccuracyCompleteness}
      </Typography>
      <Typography component='h5' className={`subHeading dark-blue`}>
        <Box mb={2} mt={3}>
          {sectionConstants.AccuracyCompleteness1}
        </Box>
        <Box mb={3}>{sectionConstants.AccuracyCompleteness2}</Box>
      </Typography>
      <Typography component='h4' className={`heading dark-blue`}>
        {sectionConstants.ModificationsToTheService}
      </Typography>
      <Typography component='h5' className={`subHeading dark-blue`}>
        <Box mb={2} mt={3}>
          {sectionConstants.ModificationsToTheService1}
        </Box>
        <Box mb={2}>{sectionConstants.ModificationsToTheService2}</Box>
        <Box mb={3}>{sectionConstants.ModificationsToTheService3}</Box>
      </Typography>
      <Typography component='h4' className={`heading dark-blue`}>
        {sectionConstants.ProductsOrServices}
      </Typography>
      <Typography component='h5' className={`subHeading dark-blue`}>
        <Box mb={2} mt={3}>
          {sectionConstants.ProductsOrServices1}
        </Box>
        <Box mb={2}>{sectionConstants.ProductsOrServices2}</Box>
        <Box mb={3}>{sectionConstants.ProductsOrServices3}</Box>
      </Typography>
      <Typography component='h4' className={`heading dark-blue`}>
        {sectionConstants.AccuracyOfBilling}
      </Typography>
      <Typography component='h5' className={`subHeading dark-blue`}>
        <Box mb={2} mt={3}>
          {sectionConstants.AccuracyOfBilling1}
        </Box>
        <Box mb={2}>{sectionConstants.AccuracyOfBilling2}</Box>
        <Box mb={3}>{sectionConstants.AccuracyOfBilling3}</Box>
      </Typography>
      <Typography component='h4' className={`heading dark-blue`}>
        {sectionConstants.OptionalTools}
      </Typography>
      <Typography component='h5' className={`subHeading dark-blue`}>
        <Box mb={2} mt={3}>
          {sectionConstants.OptionalTools1}
        </Box>
        <Box mb={2}>{sectionConstants.OptionalTools2}</Box>
        <Box mb={2}>{sectionConstants.OptionalTools3}</Box>
        <Box mb={3}>{sectionConstants.OptionalTools4}</Box>
      </Typography>
      <Typography component='h4' className={`heading dark-blue`}>
        {sectionConstants.ThirdPartyLinks}
      </Typography>
      <Typography component='h5' className={`subHeading dark-blue`}>
        <Box mb={2} mt={3}>
          {sectionConstants.ThirdPartyLinks1}
        </Box>
        <Box mb={2}>{sectionConstants.ThirdPartyLinks2}</Box>
        <Box mb={3}>{sectionConstants.ThirdPartyLinks3}</Box>
      </Typography>
      <Typography component='h4' className={`heading dark-blue`}>
        {sectionConstants.UserComments}
      </Typography>
      <Typography component='h5' className={`subHeading dark-blue`}>
        <Box mb={2} mt={3}>
          {sectionConstants.UserComments1}
        </Box>
        <Box mb={2}>{sectionConstants.UserComments2}</Box>
        <Box mb={3}>{sectionConstants.UserComments3}</Box>
      </Typography>
      <Typography component='h4' className={`heading dark-blue`}>
        {sectionConstants.PersonalInformation}
      </Typography>
      <Typography component='h5' className={`subHeading dark-blue`}>
        <Box mb={3} mt={3}>
          {sectionConstants.PersonalInformation1}
        </Box>
      </Typography>
      <Typography component='h4' className={`heading dark-blue`}>
        {sectionConstants.ErrosIn}
      </Typography>
      <Typography component='h5' className={`subHeading dark-blue`}>
        <Box mb={2} mt={3}>
          {sectionConstants.ErrosIn1}
        </Box>
        <Box mb={3}>{sectionConstants.ErrosIn2}</Box>
      </Typography>
      <Typography component='h4' className={`heading dark-blue`}>
        {sectionConstants.ProhibitedUsers}
      </Typography>
      <Typography component='h5' className={`subHeading dark-blue`}>
        <Box mb={3} mt={3}>
          {sectionConstants.ProhibitedUsers1}
        </Box>
      </Typography>
      <Typography component='h4' className={`heading dark-blue`}>
        {sectionConstants.DisclaimerOf}
      </Typography>
      <Typography component='h5' className={`subHeading dark-blue`}>
        <Box mb={2} mt={3}>
          {sectionConstants.DisclaimerOf1}
        </Box>
        <Box>{sectionConstants.DisclaimerOf2}</Box>
        <Box mb={2}>{sectionConstants.DisclaimerOf3}</Box>
        <Box mb={3}>{sectionConstants.DisclaimerOf4}</Box>
      </Typography>
      <Typography component='h4' className={`heading dark-blue`}>
        {sectionConstants.Indemntification}
      </Typography>
      <Typography component='h5' className={`subHeading dark-blue`}>
        <Box mb={3} mt={3}>
          {sectionConstants.Indemntification1}
        </Box>
      </Typography>
      <Typography component='h4' className={`heading dark-blue`}>
        {sectionConstants.Severability}
      </Typography>
      <Typography component='h5' className={`subHeading dark-blue`}>
        <Box mb={3} mt={3}>
          {sectionConstants.Severability1}
        </Box>
      </Typography>
      <Typography component='h4' className={`heading dark-blue`}>
        {sectionConstants.Termination}
      </Typography>
      <Typography component='h5' className={`subHeading dark-blue`}>
        <Box mb={2} mt={3}>
          {sectionConstants.Termination1}
        </Box>
        <Box mb={3}>{sectionConstants.Termination2}</Box>
      </Typography>
      <Typography component='h4' className={`heading dark-blue`}>
        {sectionConstants.EntireAgreement}
      </Typography>
      <Typography component='h5' className={`subHeading dark-blue`}>
        <Box mb={2} mt={3}>
          {sectionConstants.EntireAgreement1}
        </Box>
        <Box mb={2}>{sectionConstants.EntireAgreement2}</Box>
        <Box mb={3}>{sectionConstants.EntireAgreement3}</Box>
      </Typography>
      <Typography component='h4' className={`heading dark-blue`}>
        {sectionConstants.GoverningLaw}
      </Typography>
      <Typography component='h5' className={`subHeading dark-blue`}>
        <Box mb={3} mt={3}>
          {sectionConstants.GoverningLaw1}
        </Box>
      </Typography>
      <Typography component='h4' className={`heading dark-blue`}>
        {sectionConstants.ChangeToTerms}
      </Typography>
      <Typography component='h5' className={`subHeading dark-blue`}>
        <Box mb={2} mt={3}>
          {sectionConstants.ChangeToTerms1}
        </Box>
        <Box mb={3}>{sectionConstants.ChangeToTerms2}</Box>
      </Typography>
      <Typography component='h4' className={`heading dark-blue`}>
        {sectionConstants.ContactInformation}
      </Typography>
      <Typography component='h5' className={`subHeading dark-blue`}>
        <Box mb={3} mt={3}>
          {sectionConstants.ContactInformation1}
        </Box>
      </Typography>
      <Typography component='h4' className={`heading dark-blue`}>
        {sectionConstants.CreditContactInformation}
      </Typography>
      <Typography component='h5' className={`subHeading dark-blue`}>
        <Box mb={3} mt={3}>
          {sectionConstants.CreditContactInformation1}
        </Box>
      </Typography>
    </Box>
  );
};
